import React from 'react'

import { cn } from 'src/helpers/style'

import styles from './styles.module.css'

export interface ILoadingProps {
  className?: string
}

const Loading = ({ className }: ILoadingProps = {}): JSX.Element => {
  return (
    <span
      className={cn(styles.loadingContainer, className)}
      data-testid="loading-component"
    >
      <span className={styles.loadingSpinner}></span>
    </span>
  )
}

const withLoading =
  (
    /**
     * The element (invoked component) to be rendered when loading is done
     */
    WrappedComponent: React.JSX.Element,
  ) =>
  (
    /**
     * Boolean that controls whether the component is loading or not
     */
    loading: boolean,
  ): React.JSX.Element =>
    loading ? <Loading /> : WrappedComponent

export { Loading, withLoading }
